// @ts-check
import React from 'react';

import Chip from '@liquidweb-dev/undercurrent/Chip';
import DisplayTypeIcon from 'components/standard/DisplayTypeIcon';

/**
 * Chip with icon and label determined by the `displayType` property from the `useAssetDetails` hook. Reminder: `displayType` requires the `alsowiths` of `altGroup`, `capabilities`, and `categories`.
 * @param {import('@liquidweb-dev/undercurrent/Chip').ChipProps & {
 *   displayType: import('modules/queries/asset/useDetails').AssetDetails['displayType'];
 * }} props
 */
const DisplayTypeChip = ({ displayType, ...rest }) => (
	<Chip
		size="small"
		icon={<DisplayTypeIcon displayType={displayType} />}
		label={displayType}
		{...rest}
	/>
);

export default DisplayTypeChip;
